<template>
  <article>
    <div class="filter">
      <div class="filter__item">
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">广告名：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    <el-table
      ref="dataTable"
      :data="lists"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%;"
      class="mt-30"
      height="600"
      :summary-method="getSummaries"
      show-summary
    >
      <!-- 统一单个循环 + 内部判断 -->
      <el-table-column
        v-for="(col, index) in tableColumns"
        :key="`${col.columnName}-${index}`"
        :prop="col.columnName"
        :label="col.columnTitle"
        align="center"
        :width="col.width"
        v-if="col.isShow"
      >
        <!-- 表头双击打开设置 -->
        <template slot="header" slot-scope="scope">
          <span @dblclick="isShowColumn = true">
            <i
              v-if="index === 0"
              class="el-icon-setting"
              style="cursor:pointer;margin-right:6px"
              @click="isShowColumn = true"
            ></i>
            {{ col.columnTitle }}
          </span>
        </template>

        <!-- 内容：所有自定义列内部判断 -->
        <template slot-scope="scope">
          <!-- 广告 -->
          <div v-if="col.columnName === 'adid'">
            {{scope.row.title}}({{scope.row.adid}})
          </div>

          <!-- 限额模式 -->
          <div v-else-if="col.columnName === 'mode'">
            <div v-if="scope.row.mode == 1" class="normal-btn">订单数</div>
            <div v-if="scope.row.mode == 0" class="danger-btn">金额</div>
          </div>

          <!-- 当日预算 -->
          <div v-else-if="col.columnName === 'quota'">
            <div v-if="scope.row.remain" class="fc-red pointer">
              {{scope.row.quota}}
            </div>
            <div v-else> {{scope.row.quota}} </div>
          </div>

          <!-- 上家/底价 -->
          <div v-else-if="col.columnName === 'aver_discount'">
            {{scope.row.aver_discount}}% / {{scope.row.min_discount}}%
          </div>

          <!-- 其他字段自动显示 -->
          <span v-else>
            {{ scope.row[col.columnName] }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, sizes, pager, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="filters.l"
      :page-sizes="[20, 50, 80, 100]"
      :total="filters.total"
      :current-page="filters.p"
      class="tac mt-36 pb-36"
    />

    <!-- 列设置组件 -->
    <TableColumnSetting
      :visible.sync="isShowColumn"
      :column-list.sync="tableColumns"
      :default-columns="defaultColumns"
      :storage-key="`${$options.name}_table_columns`"
    />
  </article>
</template>

<script>
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {adDayBudget, adPeriodDayBudget, downloadAdOrderLists} from '../../../api/api'
import adSelect from '../../../components/data-select/adSelect.vue'

export default {
  name: 'adDayBudget',
  mixins: [mixinList],
  components: {
    adSelect
  },
  data () {
    return {
      lists: [],
      listLoading: false,
      isShowColumn: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        title: ''
      },
      adLists: [],
      // 你的列配置 + isSum
      defaultColumns: [
        { columnName: 'date', columnTitle: '日期', isShow: true, isSum: false },
        { columnName: 'adid', columnTitle: '广告', isShow: true, isSum: false },
        { columnName: 'oper_nickname', columnTitle: '负责人', isShow: true, isSum: false },
        { columnName: 'aver_name', columnTitle: '上家', isShow: true, isSum: false },
        { columnName: 'mode', columnTitle: '限额模式', isShow: true, isSum: false },
        { columnName: 'quota', columnTitle: '当日预算', isShow: true, isSum: true },
        { columnName: 'ocount', columnTitle: '有效订单数', isShow: true, isSum: true },
        { columnName: 'payment', columnTitle: '有效金额', isShow: true, isSum: true },
        { columnName: 'aver_discount', columnTitle: '上家/底价', isShow: true, isSum: false }
      ],
      tableColumns: []
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    getSummaries (param) {
      return util.getSummaries(param, this.defaultColumns)
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      this.listLoading = true

      if (filters.title !== '') {
        params.title = filters.title
      }

      let condition = true
      if (filters.adid !== '') {
        params.adid = filters.adid
        condition = false
      }

      (condition ? adDayBudget : adPeriodDayBudget)(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.adid': 'getList',
    'filters.title': 'getList'
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/module/ad/adDayBudget.vue